<template>
    <div class="flex gap-1">
        <component
            :is="Boolean(props.overrideElement) ? props.overrideElement : 'label'"
            :id="props.id"
            :for="Boolean(props.overrideElement) ? undefined : inputId"
            class="flex text-sm font-medium text-nowrap"
            :class="[props.isDisabled ? 'text-gray-500' : 'text-gray-700']"
        >
            {{ label }}

            <Tooltip v-if="props.isRequired" class="ml-1">
                <template #trigger="tooltipProps">
                    <span
                        class="cursor-help focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-700 rounded-[0.0625rem]"
                        :class="[props.isDisabled ? 'text-gray-500' : 'text-red-700']"
                        v-bind="tooltipProps"
                        :tabindex="0"
                    >
                        *
                    </span>
                </template>

                <template #text>
                    {{ $t('required-field') }}
                </template>
            </Tooltip>
        </component>

        <HelpButton v-if="helpButtonText" :text="helpButtonText" />
    </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue';
import HelpButton from '../HelpButton/HelpButton.vue';
import Tooltip from '../Tooltip/Tooltip.vue';

type LabelProps = {
    id?: string;
    label: string;
    inputId: string;
    helpButtonText?: string;
    isRequired?: boolean;
    isDisabled?: boolean;
    overrideElement?: 'div' | 'legend' | Component;
};

const props = defineProps<LabelProps>();
</script>
